var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCrossIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.74 1.5a7.24 7.24 0 100 14.48 7.24 7.24 0 000-14.48zM0 8.74a8.74 8.74 0 1117.48 0A8.74 8.74 0 010 8.74z",
    fill: "#36354C"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.5 5.98a.75.75 0 010 1.061l-4.46 4.46a.75.75 0 01-1.06-1.061l4.459-4.46a.75.75 0 011.06 0z",
    fill: "#36354C"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.5 11.5a.75.75 0 01-1.061 0l-4.46-4.459a.75.75 0 011.061-1.06l4.46 4.459a.75.75 0 010 1.06z",
    fill: "#36354C"
  })));
}
export default SvgCrossIcon;